<style lang="stylus"></style>

<template>
    <div class="search-line">
        <div class="search-back" @click="searchBack">
            <img src="@/home/assets/pcview/back.svg" alt="" />
            <p>{{ $t("return") }}</p>
        </div>

        <i18n path="result" tag="p" class="search-result">
            <template #data>
                <span class="search-result-blue">{{ `"${str}"` }}</span>
            </template>

            <template #num>
                {{ num }}
            </template>
        </i18n>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class Searchback extends Vue {
        @Prop()
        str;
        @Prop()
        num;
        //生命周期
        searchBack() {
            this.$bus.$emit("files_cleanSearch");
            this.$emit("searchBack");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
    "zh": {
        "return": "返回",
        "result": "{data}的搜索结果（{num}）"
    },
    "en": {
        "return": "Return",
        "result": "{data} Search results ({num})"},
    "fr": {
        "return": "Retour",
        "result": "{data} Résultats de la recherche ({num})"
    },
    "de": {
        "return": "Zurück",
        "result": "{data} Suchergebnisse ({num})"
    },
    "jp": {
        "return": "戻る",
        "result": "{data}検索結果({num})"
    },
    "es": {
        "return": "Volver",
        "result": "{data} Resultados de búsqueda ({num})"
    },
    "pt": {
        "return": "Retornar",
        "result": "{data} Resultados da pesquisa ({num})"
    },
    "it": {
        "return": "Indietro",
        "result": "{data} Risultati della ricerca ({num})"
    },
    "tw": {
        "return": "返回",
        "result": "{data}搜尋結果({num})"
    },
    "kr": {
        "return": "돌아가기",
        "result": "{data}검색 결과({num})"
    }
}
</i18n>
